module.exports = __webpack_public_path__ + "static/media/packc1.984743cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/packc1.jpg
// module id = 887
// module chunks = 0